import { ButtonText, LoginConstants } from "../../constants/constants";
import DividerIcon from "../../mobileResponsive/assets/DividerIcon";
import Button from "./cta/Button";
import { useLocation } from "react-router-dom";
import { readFromLocalStorage } from "../../utils/DataEncryption";


const TVSMUserLogin = ({textStyle,buttonPadding}:{textStyle:string,buttonPadding:string}) => {
  const location = useLocation();
  const locationState = location.state || {};
  let selectedMethod = locationState?.selectedMethod;

  const handleTVSMUserLogin = () => {
    const urlString = window.location.href; // Or any URL string
    const url = new URL(urlString);
    const params = new URLSearchParams(url.search);
    const callBackUrlFromParms = params.get("callback_uri");
    const appIdFromParms = params.get("app_id");
    const appId =
      appIdFromParms ||
      readFromLocalStorage("appId") ||
      process.env.REACT_APP_APPID;
    const callbackUrl =
      callBackUrlFromParms || process.env.REACT_APP_LOGIN_REDIRECT_URL;
    const loginURL = `${process.env.REACT_APP_LOGINURL}/auth/v1/app/token`;
    let URLString = `${loginURL}?app_id=${appId}&callback_uri=${callbackUrl}&aut=tvsm`;
    window.location.href = URLString;
  };

  return (
    <div className=" ">
      <div className="flex justify-center items-center">
        <DividerIcon />
        <div
          className={`${
           textStyle
          }`}
        >
          {LoginConstants.OrLoginWith}
        </div>
        <DividerIcon />
      </div>
      <div className="flex justify-center pb-4">
        <Button
          buttonText={ButtonText.tvsmUserLogin}
          handleClick={() => handleTVSMUserLogin()}
          className={` ${buttonPadding} text-primary font-bold border border-primary rounded-md font-nunito cursor-pointer  whitespace-nowrap`}
        />
      </div>
    </div>
  );
};

export default TVSMUserLogin;
